import {
  Paper,
  TypographyElement,
  Button,
  ButtonVariation,
  ButtonSize,
  Skeleton
} from 'UI'
import Text from './text.json'
import { createUseStyles } from 'react-jss'
import styles from './style'
import { decorateUrl } from 'components/common/UTMscript'
import { ExternalAlphormPages } from 'constants/'

const useStyle = createUseStyles(styles)

export default ({ margin, isFrance, loading, code, noFlex }) => {
  const { paperClass, textSection } = useStyle({ margin, noFlex })
  if (!isFrance) return null
  const utm = `utm_term=fpbutton&utm_content=${code}`
  return (
    <Paper className={paperClass}>
      <div className={textSection}>
        {
          loading
            ? <Skeleton lines={1} width='100%' height={26} margin='0 0 16px 0' />
            : (
              <TypographyElement
                variant='heading5'
                spacing='0 0 8px 0'
                Component='h3'
              >
                {Text.boostCareer}
              </TypographyElement>
              )
        }
        {
          loading
            ? <Skeleton lines={2} width={['100%', '80%']} height={15} gap={12} margin='0 0 16px 0' />
            : (
              <TypographyElement
                variant='body1'
                spacing='0 0 16px 0'
              >
                {Text.funding}
              </TypographyElement>
              )
        }
      </div>
      <Button
        key={`${Text.button}-${loading}`}
        loading={loading}
        Component='a'
        dataTest='access-cpf-button'
        variation={ButtonVariation.secondary}
        size={ButtonSize.small}
        label={Text.fundingButton}
        width='100%'
        href={decorateUrl(ExternalAlphormPages.Funding, utm)}
        onHandleClick={() => window.open(decorateUrl(ExternalAlphormPages.Funding, utm), '_blank')}
      />
    </Paper>
  )
}
